// extracted by mini-css-extract-plugin
module.exports = {"container":"RetailerGuard_container__1a75H"};